import { apiGetRequest, apiPostRequest } from "../utils/webrequests";
import {PartnerInfo, PartnerListItem} from "../data/partnerData";
import {UserRole} from "../data/userRole";

export async function getPartnersList(): Promise<PartnerListItem[]> {
    try {
        const partners = await apiGetRequest("GetPartners", null) as PartnerListItem[];
        return partners;
    } catch (error: any) {
        console.error('Error in getPartnersList:', error);
        throw new Error('Error fetching partners list: ' + error.message);
    }
}

export async function deletePartner(partnerId: string): Promise<boolean> {
    try {
        const response = await apiPostRequest(`partners/${partnerId}`, {});
        return true;
    } catch (error: any) {
        if (error.status === 404) {
            throw new Error('Partner not found');
        } else if (error.status === 401) {
            throw new Error('Unauthorized to delete partner');
        }
        throw new Error('Error deleting partner: ' + error.message);
    }
}

export async function addPartner(partner: PartnerInfo): Promise<PartnerInfo> {
    try {
        // Make an API GET request to fetch event info
        const data: PartnerInfo = await apiPostRequest("AddPartner", partner)
        // Return the fetched data
        return data;

    } catch (error: any) {
        console.error('Error in addPartner:', error);
        throw new Error('Error adding partner: ' + error.message);
    }
}

export async function editPartner(partner: PartnerListItem): Promise<boolean> {
    try {
        const response = await apiPostRequest(`editPartners/${partner.PartnerId}`, partner);
        return true;
    } catch (error: any) {
        if (error.status === 404) {
            throw new Error('Partner not found');
        } else if (error.status === 401) {
            throw new Error('Unauthorized to edit partner');
        }
        throw new Error('Error editing partner: ' + error.message);
    }
}